"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    width: 'auto',
    height: 'auto',
    zIndexRoot: palette.zOverlay,
    overlayColor: palette.elSecondaryAccent,
    overlayOpacity: '0.87',
    overlaySize: palette.gutter * 65 + 'px',
    overlayPositionTop: '50%',
    overlayPositionLeft: '50%',
    overlayPositionTransform: 'translate(-50%, -50%)',
    overlayTransformOrigin: 'center',
    overlayAnimationName: null,
    overlayAnimationNameOut: null,
    overlayAnimationDuration: '.5s',
    overlayAnimationTimingFunction: 'linear',
    overlayAnimationIterationCount: '1',
    overlayAnimationFillMode: 'forwards',
    pulsarColor: palette.elPrimary,
    pulsarSize: palette.gutter * 6 + 'px',
    pulsarAnimationName: null,
    pulsarAnimationNameOut: 'none',
    pulsarAnimationDuration: '1.2s',
    pulsarAnimationDelay: '0s',
    pulsarAnimationTimingFunction: 'linear',
    pulsarAnimationIterationCount: 'infinite',
    placeholderColor: palette.elPrimary,
    placeholderSize: palette.gutter * 6 + 'px',
    placeholderAnimationName: null,
    placeholderAnimationNameOut: 'none',
    placeholderAnimationDuration: '1.2s',
    placeholderAnimationTimingFunction: 'linear',
    placeholderAnimationIterationCount: 'infinite',
    contentWrapperAnimationName: null,
    contentWrapperAnimationNameOut: null,
    contentWrapperAnimationDuration: '.3s',
    contentWrapperAnimationTimingFunction: 'linear',
    contentWrapperAnimationIterationCount: '1',
    contentWrapperAnimationFillMode: 'forwards',
    hintLeft: "-".concat(palette.gutter * 13, "px"),
    hintTop: "".concat(palette.gutter * 6, "px"),
    wrapperBackgroundColor: palette.elPrimary,
    onClickInterceptorCursor: 'pointer'
  };
}